import { Injectable } from "@angular/core";
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { LoginDialogComponent } from "../components/login-dialog/login-dialog.component";
import { YoutubeDialogComponent } from "../components/youtube-dialog/youtube-dialog.component";
import { PlaylistDialogComponent } from "../components/playlist-dialog/playlist-dialog.component";
import { ShareDialogComponent } from "../components/share-dialog/share-dialog.component";
// import { CartDialogComponent } from "../components/cart-dialog/cart-dialog.component";
// Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
import { ReportDialogComponent } from "../components/report-dialog/report-dialog.component";
import { UpgradeAccountDialogComponent } from "../components/upgrade-account/upgrade-account-dialog.component";
import { Observable } from "rxjs";
import { of } from "rxjs";
import { GlobalService } from "./global.service";
import { VerifyEmailComponent } from "../components/verify-email/verify-email.component";
import { VerifyPhoneComponent } from "../components/verify-phone/verify-phone.component";
import { UserService } from "./user.service";
import { CustomDialogComponent } from "../components/custom-dialog/custom-dialog.component";
import { RegisterComponent } from "../components/register/register.component";
import { LyricsDialogComponent } from "../components/lyrics-dialog/lyrics-dialog.component";
import { ExitPopUpComponent } from "../components/exit-pop-up/exit-pop-up.component";
import { Router } from "@angular/router";
import { ScreenGuideComponent } from "../components/artist-dashboard/screen-guide/screen-guide.component";
import { EpkDialogComponent } from "../profile/components/epk-dialog/epk-dialog.component";
import { SubsriptionPopupComponent } from "../subscription/subsription-popup/subsription-popup.component";
@Injectable({
    providedIn: "root",
})

export class DialogService {

    backdrop: any = true;
    backdropClass: any = "dialogBackdrop";
    focus: any = false;
    navigationClose: any = true;
    disableClose: any = false;
    maxWidth: any = "calc(100% - 16px)";
    showPopup: Boolean = true;
    percentage_height = 0.4;
    currountRoute: String = "";
    src: String = "";
    epkDialogRef: MatDialogRef<EpkDialogComponent>;
    subscriptionDialodRef: MatDialogRef<SubsriptionPopupComponent>;
    constructor(
        private dialog: MatDialog,
        private global: GlobalService,
        public user: UserService,
        private router: Router
    ) { }

    loginDialogRef: MatDialogRef<LoginDialogComponent>;
    registerDialogRef: MatDialogRef<RegisterComponent>;
    youtubeDialogRef: MatDialogRef<YoutubeDialogComponent>;
    playlistDialogRef: MatDialogRef<PlaylistDialogComponent>;
    shareDialogRef: MatDialogRef<ShareDialogComponent>;
    // cartDialogRef: MatDialogRef<CartDialogComponent>;
    //  Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
    reportDialogRef: MatDialogRef<ReportDialogComponent>;
    upgradeAccountDialogComponentRef: MatDialogRef<UpgradeAccountDialogComponent>;
    verifyEmailDialogRef: MatDialogRef<VerifyEmailComponent>;
    verifyPhoneDialogRef: MatDialogRef<VerifyPhoneComponent>;
    customDialogRef: MatDialogRef<CustomDialogComponent>;
    lyricsDialogRef: MatDialogRef<LyricsDialogComponent>;
    popupDialogRef: MatDialogRef<ExitPopUpComponent>;
    screenGuideRef: MatDialogRef<ScreenGuideComponent>;

    public openLoginDialog(
        tabValue,
        type = "",
        from = "",
        redirectTo = "",
        actions = {}
    ) {
        let userLastClickLocation = from;
        let userLastClickFrom = from;
        if (from == "sign-in" || from == "register") {
            userLastClickLocation = "top-navigation-" + from;
            userLastClickFrom = "top-navigation";
        }
        if (
            this.router.url ==
            "/opportunities/mgtaal?login=opportunities%2Fmgtaal%2Fapply"
        ) {
            this.backdropClass = "dialogBackWhite";
        } else {
            this.backdropClass = "dialogBackdrop";
        }

        this.loginDialogRef = this.dialog.open(LoginDialogComponent, {
            data: {
                tab: tabValue,
                type: type,
                from: from,
                redirectTo: redirectTo,
                actions: actions,
                userLastClickLocation: userLastClickLocation,
                userLastClickFrom: userLastClickFrom,
            },
            id: "loginDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: true,
            maxWidth: this.maxWidth
        });
    }

    public openScreenGuide() {
        // console.log('Dialog for screen guide run')
        this.dialog.closeAll();
        this.screenGuideRef = this.dialog.open(ScreenGuideComponent);
    }

    public checkSubAndchangeRoute(url) {
        return true;
        let x = this.global.CheckUserProStatus();
        if (x && url != "") {
            this.router.navigate([url]);
            return 0;
        } else if (x && url == "") {
            return 1;
        } else {
            this.openSubscriptionDialog();
            return 0;
        }
    }
    public openYoutubeDialog(video) {
        if (this.isDialogOpen("youtubeDialog")) {
            this.youtubeDialogRef.close();
            if (this.global.isBrowser) {
                $(".dialogClose").click();
            }

            const angularthis = this;
            setTimeout(function () {
                angularthis.openYoutube(video);
            }, 500);
        } else {
            this.openYoutube(video);
        }
    }

    public openYoutubeDialogV2(video) {
        if (this.isDialogOpen("youtubeDialog")) {
            this.youtubeDialogRef.close();
            if (this.global.isBrowser) {
                $(".dialogClose").click();
            }

            const angularthis = this;
            setTimeout(function () {
                angularthis.openYoutubeV2(video);
            }, 500);
        } else {
            this.openYoutubeV2(video);
        }
    }
    public openYoutube(video) {
        this.youtubeDialogRef = this.dialog.open(YoutubeDialogComponent, {
            data: {
                slug: video.slug_uservideo,
                src: video.youtube_video_id,
                title: video.title,
                artist: video.user.full_name,
                artistSlug: video.user.slug_username,
                clapsCount: video.is_like,
                totalClapsCount: video.video_likes,
                image: video["img_480x360"],
                footer: true,
            },
            id: "youtubeDialog",
            hasBackdrop: false,
            autoFocus: this.focus,
            closeOnNavigation: false,
            disableClose: this.isMobile() ? false : true,
            maxWidth: this.maxWidth,

        });

        if (this.global.isBrowser) {
            $(".cdk-global-overlay-wrapper").addClass("overlayBG");
        }

        this.youtubeDialogRef
            .afterClosed()
            .subscribe((name) => (this.src = ""));
    }

    public openYoutubeV2(video) {
        this.youtubeDialogRef = this.dialog.open(YoutubeDialogComponent, {
            data: {
                slug: video.video_slug,
                src: video.youtube_video_id,
                title: video.title,
                artist: video.name,
                artistSlug: video.artist_slug,
                clapsCount: 10,
                totalClapsCount: 10,
                image: video["img_480x360"],
                footer: false,
            },
            id: "youtubeDialog",
            hasBackdrop: false,
            autoFocus: this.focus,
            closeOnNavigation: false,
            disableClose: this.isMobile() ? false : true,
            maxWidth: this.maxWidth,
        });

        if (this.global.isBrowser) {
            $(".cdk-global-overlay-wrapper").addClass("overlayBG");
        }

        this.youtubeDialogRef
            .afterClosed()
            .subscribe((name) => (this.src = ""));
    }

    public openPlaylistDialog(tracks) {
        this.playlistDialogRef = this.dialog.open(PlaylistDialogComponent, {
            data: { tracks: tracks },
            id: "playlistDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }

    public openShareDialog(
        type,
        slug,
        title = "",
        artist = "",
        image: any,
        customData = {}
    ) {
        this.shareDialogRef = this.dialog.open(ShareDialogComponent, {
            data: {
                type: type,
                slug: slug,
                title: title,
                artist: artist,
                image: image,
                customData: customData,
            },
            id: "shareDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }
    //  Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
    // public openCartDialog(sku) {
    //     this.cartDialogRef = this.dialog.open(CartDialogComponent, {
    //         data: { sku: sku },
    //         id: "cartDialog",
    //         hasBackdrop: this.backdrop,
    //         backdropClass: this.backdropClass,
    //         autoFocus: this.focus,
    //         closeOnNavigation: this.navigationClose,
    //         disableClose: this.disableClose,
    //         maxWidth: this.maxWidth,
    //         panelClass: "my-custom-dialog-class",
    //     });
    // }

    public openReportDialog() {
        this.reportDialogRef = this.dialog.open(ReportDialogComponent, {
            id: "reportDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }

    public openUpgradeAccountDialog(from = "") {
        this.upgradeAccountDialogComponentRef = this.dialog.open(
            UpgradeAccountDialogComponent,
            {
                data: { from: from },
                id: "upgradeAccountDialog",
                hasBackdrop: this.backdrop,
                backdropClass: this.backdropClass,
                autoFocus: this.focus,
                closeOnNavigation: this.navigationClose,
                disableClose: this.disableClose,
                maxWidth: this.maxWidth,
            }
        );
    }

    openVerifyEmailDialog(email = this.user.email, autoSend = true, from = '') {
        this.verifyEmailDialogRef = this.dialog.open(VerifyEmailComponent, {
            data: { email: email, autoSend: autoSend, from: from },
            id: "otpDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
            panelClass: "veryfy-email-dialog-class",
        });
                    return this.verifyEmailDialogRef;

    }

    openVerifyPhoneDialog(mobile = this.user.mobile, countrycode, autoSend = true) {
        this.verifyPhoneDialogRef = this.dialog.open(VerifyPhoneComponent, {
            data: { mobile: mobile, code: countrycode, autoSend: autoSend },
            id: 'otpDialog',
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
            panelClass: 'veryfy-phone-dialog-class'
        });
                    return this.verifyPhoneDialogRef;

    }

    openSubscriptionDialog() {
        this.subscriptionDialodRef = this.dialog.open(
            SubsriptionPopupComponent,
            {
                data: {},
                id: "subscriptionDialog",
                hasBackdrop: this.backdrop,
                backdropClass: this.backdropClass,
                autoFocus: this.focus,
                closeOnNavigation: this.navigationClose,
                disableClose: this.disableClose,
                maxWidth: this.maxWidth,
            }
        );
        return this.subscriptionDialodRef;
    }

    openCustomDialog(type = "opp_save", tool = "", isReleased = true) {
        this.customDialogRef = this.dialog.open(CustomDialogComponent, {
            data: { type: type, tool: tool, isReleased: isReleased },
            id: "customDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }
    openEpkDialog() {
        this.epkDialogRef = this.dialog.open(EpkDialogComponent, {
            data: {},
            id: "epkDialog",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }
    openRegisterDialog(formStep, email, userLastClickFrom) {
        this.registerDialogRef = this.dialog.open(RegisterComponent, {
            data: {
                formStep: formStep,
                email: email,
                userLastClickFrom: userLastClickFrom,
            },
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }

    openLyricsDialogRef(lyrics, from) {

        this.lyricsDialogRef = this.dialog.open(LyricsDialogComponent, {
            data: { text: lyrics, from: from },
            id: "lyrics",
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth,
        });
    }

    public isDialogOpen(id) {
        const status = this.dialog.getDialogById(id) != undefined;
        // console.log( status );
        return status;
    }

    isMobile() {
        return window.innerWidth <= 767 ? true : false;
    }

    confirm(message?: string): Observable<boolean> {
        const confirmation = window.confirm(message || "Are you sure?");

        return of(confirmation);
    }
}
